module.exports = __webpack_public_path__ + "static/media/last-node-with-child.10613d86.svg";